import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {Alert} from '../functions'

// eslint-disable-next-line no-undef
const object = vnObject

window.Parsley.addValidator('frNumber', {
    requirementType: 'string',
    validateString: function (value) {
        return isValidPhoneNumber(value, 'FR')
    },
})

const proRegisterForm = $('.pro-register-form')

if (proRegisterForm.length) {
    proRegisterForm.parsley().on('form:success', function () {
        proRegisterForm.attr('data-success', 'true')
    })

    proRegisterForm.parsley().on('form:error', function () {
        proRegisterForm.attr('data-success', 'false')
    })

    proRegisterForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const $proRegisterForm = $(this)

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: $proRegisterForm.serialize() + '&action=' + 'vn_pro_register',
            beforeSend: () => {
                $proRegisterForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            success: (res) => {
                $proRegisterForm.removeClass('sending')

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }

                Alert(res.success, res.data.message)

                res.success && $proRegisterForm[0].reset()
            },
        })
    })
}
